import ApiCompanyImage from 'types/api/CompanyImage';

import FileUpload from 'models/FileUpload';
import Model from 'models/Model';

export default class CompanyImage implements Model {
    id: string;
    createAt: string;
    file: FileUpload;

    constructor(data: ApiCompanyImage) {
        this.id = data.id;
        this.createAt = data.createAt;
        this.file = data.file && new FileUpload(data.file);
    }
}